export default "__VITE_ASSET__BqJ3zj$q__"